import React from "react";

import * as dateish from "js/dateish";

import classes from './calendar.module.css';

// TODO: These should be generative components via polymorphism
// The render* functions can return a <td> for direct use. If another element
// type is returned, it will be wrapped in a <td>
export type Props = {
  renderDay?: (day: dateish.CalDay) => React.ReactNode
  renderMonth?: (month: dateish.CalMonth) => React.ReactNode // todo this is only the month header
  // todo: render week as well...
}

export const CalendarYearless = (props: Props) => {
  const months = dateish.yearlessMonths();
  return <div className={ classes.calendar }>
    { months.map(m => <CalendarMonth key={m.month.mm} month={m} {...props} />) }
  </div>;
}

export const CalendarMonth = (props: Props & { month: dateish.CalMonth }) => {
  const { month, renderDay, renderMonth = defaultRenderMonth } = props;

  let monthDiv = renderMonth(month);
  if (!React.isValidElement(monthDiv) || monthDiv.type !== 'td') {
    // TODO: May also need to set the colSpane
    monthDiv = <td colSpan={7}>{ monthDiv }</td>
  }
  // monthDiv.props['colSpan'] = 7; // TODO: is this even valid?

  return <table className={ classes.month }>
    <thead><tr className={ classes.month_row }>{ monthDiv }</tr></thead>
    <tbody>{ month.weeks.map(w => <CalendarWeek key={ w.wom } week={w} renderDay={renderDay} />) }</tbody>
  </table>;
}

export const defaultRenderMonth = (m: dateish.CalMonth) => {
  return <td colSpan={7}>
    <time className={ classes.month_name }>{ m.month.name }</time>
  </td>
}

type WeekProps = Omit<Props, 'renderMonth'> & { week: dateish.CalWeek };

export const CalendarWeek = ({ week, renderDay }: WeekProps) => {
  return <tr className={ classes.week }>{ week.days.map(d => {
    return <CalendarDay key={ d.doy } day={ d } renderDay={ renderDay } />
  }) }</tr>;
}

type DayProps = Omit<Props, 'renderMonth'> & { day: dateish.CalDay };

export const CalendarDay = ({ day, renderDay = defaultRenderDay }: DayProps) => {
  const node = renderDay(day);
  if (React.isValidElement(node) && node.type === 'td') {
    return node;
  }

  return <td className={ classes.day } >{ node }</td>;
}

export const defaultRenderDay = (day: dateish.CalDay) => {
  return <td className={ classes.day } >
    <time className={ classes.date }>{ day.dom }</time>
  </td>;
}
